import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
	state: false,
	notification : false,
	active_user : 0,
	max_user : 0,
	selectedProjectsList : [],
	team : [],
	options: {
		children: null
	}
};
const userManagement = createSlice({
	name: 'member',
	initialState: initialState,
	reducers: {
		openDialog: (state: any, action: PayloadAction<any>) => {
			state.state = true;
			state.options = action.payload;
		},
		closeDialog: (state: any, action: PayloadAction<any>) => {
			state.state = false;
			state.options = action.payload;
		},
		showNotification: (state: any) => {
			state.notification = true;
		},
		hideNotification: (state: any) => {
			state.notification = false;
		},
		incrementActiveUser: (state : any) => {
			state.active_user += 1
		},
		updateActiveUser: (state: any, action: PayloadAction<number> ) => {
			state.active_user = action.payload;
		},
		updateMaxUser: (state: any, action: PayloadAction<number>) => {
			state.max_user = action.payload;
		},
		updateTeam: (state: any, action: PayloadAction<number>) => {
			state.team = action.payload;
		},
		refreshProjectsList: (state: any, action: PayloadAction<any>) => {
			state.selectedProjectsList = action.payload;
		},
	}
});

export const { openDialog, closeDialog, showNotification, hideNotification, incrementActiveUser, updateActiveUser, updateMaxUser, updateTeam, refreshProjectsList } = userManagement.actions;

export default userManagement.reducer;
